/* eslint-disable */
import clsx from 'clsx';
import {
	ArrayFieldTemplateItemType,
	ArrayFieldTemplateProps,
	FormContextType,
	getTemplate,
	getUiOptions,
	RJSFSchema,
	StrictRJSFSchema,
} from '@rjsf/utils';
import React from 'react';

import styles from './style.module.sass';

function ArrayFieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(
	props: ArrayFieldTemplateProps<T, S, F>
) {
	const {
		canAdd,
		className,
		disabled,
		formContext,
		idSchema,
		items = [],
		onAddClick,
		readonly,
		registry,
		required,
		schema,
		title,
		uiSchema,
	} = props;
	const uiOptions = getUiOptions<T, S, F>(uiSchema);
	const ArrayFieldDescriptionTemplate = getTemplate<'ArrayFieldDescriptionTemplate', T, S, F>(
		'ArrayFieldDescriptionTemplate',
		registry,
		uiOptions
	);
	const ArrayFieldItemTemplate = getTemplate<'ArrayFieldItemTemplate', T, S, F>(
		'ArrayFieldItemTemplate',
		registry,
		uiOptions
	);
	const ArrayFieldTitleTemplate = getTemplate<'ArrayFieldTitleTemplate', T, S, F>(
		'ArrayFieldTitleTemplate',
		registry,
		uiOptions
	);
	// Button templates are not overridden in the uiSchema
	const {
		ButtonTemplates: { AddButton },
	} = registry.templates;

	return (
		<fieldset id={idSchema.$id} className={clsx(className, styles.fieldset)}>
			{(uiOptions.title || title) && (
				<ArrayFieldTitleTemplate
					idSchema={idSchema}
					required={required}
					title={uiOptions.title || title}
					schema={schema}
					uiSchema={uiSchema}
					registry={registry}
				/>
			)}

			{(uiOptions.description || schema.description) && (
				<div>
					<ArrayFieldDescriptionTemplate
						description={uiOptions.description || schema.description}
						idSchema={idSchema}
						schema={schema}
						uiSchema={uiSchema}
						registry={registry}
					/>
				</div>
			)}

			<div data-role="ArrayFieldTemplate" className="array-item-list flex flex-col gap-y-5">
				{items.map(({ key, ...itemProps }: ArrayFieldTemplateItemType<T, S, F>) => (
					<ArrayFieldItemTemplate key={key} {...itemProps} hasRemove={!formContext?.disableArrayActions} />
				))}
			</div>

			{/* TODO: custom ArrayFieldTemplate for template form, and delete disableArrayActions prop */}
			{canAdd && !formContext?.disableArrayActions && (
				<AddButton
					className="mt-8"
					disabled={disabled || readonly}
					onClick={onAddClick}
					uiSchema={uiSchema}
					registry={registry}
				/>
			)}
		</fieldset>
	);
}

export { ArrayFieldTemplate };
